/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from "@cian/http-api/shared/http";
import {
  TBookCoworkingModel,
  IBookCoworkingRequest,
  IMappers,
  IBookCoworkingResponse,
  IBookCoworkingResponseError,
  TBookCoworkingResponse
} from "./types";

const defaultConfig: TBookCoworkingModel = {
  apiType: "public",
  assertStatusCodes: [200, 400],
  method: "POST",
  microserviceName: "coworking",
  pathApi: "/v1/book-coworking/",
  hostType: "ud-api"
} as TBookCoworkingModel;

function createBookCoworkingModel(
  parameters: IBookCoworkingRequest
): TBookCoworkingModel {
  return {
    ...defaultConfig,
    parameters
  };
}

export interface IBookCoworkingOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IBookCoworkingRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchBookCoworking<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers
}: IBookCoworkingOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TBookCoworkingResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createBookCoworkingModel(parameters),
    config
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IBookCoworkingResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IBookCoworkingResponseError);
    }
  }

  return { response, statusCode } as TBookCoworkingResponse;
}

export { defaultConfig, createBookCoworkingModel, fetchBookCoworking };
